import { render, staticRenderFns } from "./MentorshipGroupChat.vue?vue&type=template&id=334b4cc6&"
import script from "./MentorshipGroupChat.vue?vue&type=script&lang=js&"
export * from "./MentorshipGroupChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports